import { Component, OnInit } from '@angular/core';
import { AccountDTO } from '../../../../shared/account-dto';
import { FooterDTO } from '../../../../shared/footer-dto';
import { AccountService } from '../account.service';
import { CustomerService } from '../customer.service';
import { FooterService } from '../footer.service';
import { TrackingService } from '../tracking.service';

@Component({
  selector: 'pv-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
  email: string;
  signupText = 'SIGN UP'
  footer: FooterDTO[];
  account: AccountDTO

  constructor(
    private accountService: AccountService,
    private customerService: CustomerService,
    private trackingService: TrackingService,
    private footerService: FooterService
  ) { }

  ngOnInit() {
    // Subscribe to account
    this.account = this.accountService.account
    this.accountService.accountSubject
    .subscribe(account => this.account = account)

    // Watch for updates on changes
    this.customerService.loginSubject
    .subscribe(() => this.footerService.getFooter())

    // Subscribe to footer
    this.footerService.footerSubject
    .subscribe(footer => this.footer = footer)
    this.footerService.getFooter()
  }

  getFooterClass() {
    if (this.account && this.account.accountStyles) {
      return this.account.accountStyles.inverse_toolbar
        ? 'inverse-footer'
        : 'normal-footer'
    }
  }

  trackFooter(button) {
    // #1200 TO DO: what is happening is not really a "generate_lead"... what is it? is it anything?
    //this.trackingService.event('generate_lead', this.account.id, { value: button });
  }

  getClass(index) {
    const footerLength = this.footer.length;
    let className = '';
    if (footerLength == 4) {
      className += 'col-md-3 col-lg-2'
      if (!index) {
        className += ' offset-lg-2'
      }
    } else if (footerLength == 3) {
      className += 'col-md-4 col-lg-2'
      if (!index) {
        className += ' offset-lg-1'
      }
    } else if (footerLength == 2) {
      className += 'col-md-4 col-lg-2'
      if (!index) {
        className += ' offset-lg-4 offset-md-3'
      }
    } else if (footerLength == 1) {
      className += 'col-md-5 col-lg-2 offset-md-3 offset-lg-5'
    }

    return className
  }
}
